import PopupBox from './PopupBox';
import WarningPopupBox from './WarningPopupBox';

export default PopupBox

export {
  WarningPopupBox
}
